import React from 'react';
import {FastField, ErrorMessage} from 'formik';
import {FormattedMessage} from 'react-intl';
import get from 'lodash/get';
import classNames from 'classnames';
import messages from '../../../res/translations/messages';
import Error from '../Error';
import SendProvider from './sendProvider/SendProvider';
import SurveyEditorBox from './editor/SurveyEditorBox';
import {TRACKERS_ARCHIVE_OPTIONS} from '../../constants';

const archiveOptions = Object.values(TRACKERS_ARCHIVE_OPTIONS).map((option) => ({value: option, label: option}));

const SurveySendingSection = ({values, errors, touched, setFieldValue, organization, intl, validationSchema}) => (
    <>
        <div className="form-group">
            <label className="col-form-label" htmlFor="sef_trackerUrl">
                <FormattedMessage {...messages.surveys.form.label.trackerBaseUrl} />
            </label>
            <FastField name="trackerUrl" type="url" id="sef_trackerUrl"
                className={classNames('form-control', {error: get(errors, 'trackerUrl') && get(touched, 'trackerUrl')})} />
            <ErrorMessage name="trackerUrl">{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
        </div>
        <SendProvider
            organization={organization} values={values} errors={errors}
            touched={touched} setFieldValue={setFieldValue} intl={intl}
            validationSchema={validationSchema}
        />
        {organization.allowTrackerArchiveManagement && (
            <SurveyEditorBox title={messages.surveys.form.label.trackersArchive}>
                <div className="form-group">
                    <label className="col-form-label" htmlFor="trackerArchiveFrequency">
                        <FormattedMessage {...messages.surveys.form.label.trackerArchiveFrequency} />
                    </label>
                    <FastField
                        className="form-control"
                        component="select"
                        id="trackerArchiveFrequency"
                        name="trackerArchiveFrequency"
                        // eslint-disable-next-line react/jsx-no-bind
                        onChange={(e) => {
                            setFieldValue('trackerArchiveFrequencyValue', e.target.value === 'trackerCreated' ? 1 : 0);
                            setFieldValue('trackerArchiveFrequency', e.target.value);
                        }}
                    >
                        {archiveOptions.map(({value, label}) => (
                            <FormattedMessage key={value} {...messages.admin.organization.trackerArchiveOptions[label]}>
                                {(txt) => <option value={value}>{txt}</option>}
                            </FormattedMessage>
                        ))}
                    </FastField>
                </div>

                {values.trackerArchiveFrequency !== 'never' && (
                    <div className="form-group">
                        <label className="col-form-label" htmlFor="trackerArchiveFrequencyValue">
                            <FormattedMessage {...messages.surveys.form.label.trackerArchiveFrequencyValue} />
                        </label>
                        <FastField
                            type="number"
                            className="form-control"
                            min={values.trackerArchiveFrequency === 'trackerCreated' ? 1 : 0}
                            id="trackerArchiveFrequencyValue"
                            name="trackerArchiveFrequencyValue"
                        />
                    </div>
                )}
            </SurveyEditorBox>
        )}
    </>
);

export default SurveySendingSection;
